import i18n from '@/i18n';
import each from 'lodash/each';
import Cove from '@ctrack/cove';

/**
 * Add a global event listener to catch all unhandled javascript errors
 */
window.addEventListener('error', () => {
  // this does not work correctly locally (but does work in the prod build) -- the webpack dev server or something else
  // is garbling the error before we get it here. leaving it here though in case we want to resurrect it and write the
  // errors back to a server or the screen or something in the future.
  /*
  let error = event.error;
  let errorDetails = {
    message: error.name + ': ' + error.message,
    stacktrace: error.stack ? error.stack : 'n/a',
    localDatetime: (new Date()).toString(),
    utcDatetime: (new Date()).toUTCString(),
    userAgent: navigator.userAgent
  };
  */

  _showError({
    message: i18n.t('error.runtimeError')
  });

  // can be used to prevent propagation & the browser from logging the error to the console, however going to let
  // it bubble up for now...
  // event.preventDefault();
});

/**
 * We may want a better mechanism of showing validation error messages, e.g. a static area at the top of the page, but
 * for now this will suffice.
 *
 * @param errors {Array} an array of all validation errors to be displayed
 */
function validationError (errors)
{
  let errorList = '<ul>';
  each(errors, (error) => { errorList += '<li>' + error + '</li>'; });
  errorList += '</ul>';

  _showError({
    message: i18n.t('error.validationError') + errorList
  });
}

/**
 * Endpoint to display a notification to the user about an AJAX error/failure.
 */
function ajaxError ()
{
  _showError({
    message: i18n.t('error.ajaxError')
  });
}

/**
 * Internal function used to show the error notification.
 *
 * @param options
 */
function _showError (options)
{
  Cove.notify({
    color: 'error',
    message: options.message
  });
}

export {
  validationError,
  ajaxError
};
